<div class="row">
    <div class="col-9">
        @if (currentDataset?.datasetTypeId === DatasetTypeEnum.PLOT) {
            <img class="image-icon-sm" src="content/images/measurements.svg" />
            <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.study-dataset.observations' | translate}}</span>
        } @else {
            <img class="image-icon-sm" src="content/images/measurements.svg" />
            <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.study-dataset.sub-observations' | translate}}</span>: <span class="value-chip-light"><truncate-span [textInput]="currentDataset?.datasetName"></truncate-span></span>
        }
        <jhi-help-link [helpKey]="HELP_MANAGE_STUDIES_SUB_OBSERVATIONS"></jhi-help-link>
    </div>
    <div class="col-3 d-flex justify-content-end align-items-center">
        @if (currentDataset?.datasetTypeId !== DatasetTypeEnum.PLOT) {
            <div ngbDropdown container="body" class="d-inline-block ps-2" placement="bottom-right">
                <button class="btn btn-sm btn-info" id="columnsDropdown" ngbDropdownToggle>
                    <span>{{ 'study-editor.study-dataset.sub-observation-actions' | translate}}</span>
                </button>
                <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                    <button *jhiHasAnyAuthority="EDIT_SUB_OBSERVATION_UNITS_NUMBER_PERMISSIONS" ngbDropdownItem type="button" class="dropdown-item" (click)="editSubObsUnitsNumber()">
                        <i class="fa fa-edit"></i><span class="ms-1">{{ 'study-editor.study-dataset.sub-observation-actions.edit.number.of.units' | translate}} </span>
                    </button>
                    <button *jhiHasAnyAuthority="DELETE_SUB_OBSERVATION_UNITS_PERMISSIONS" ngbDropdownItem type="button" class="dropdown-item text-danger" (click)="deleteDataset()">
                        <i class="fa fa-trash"></i><span class="ms-1">{{ 'study-editor.study-dataset.sub-observation-actions.delete-sub-observations' | translate}} </span>
                    </button>
                </div>
            </div>
        }
    </div>
</div>
<div class="row">
        <div class="col-6">
            <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{ 'study-editor.study-dataset.traits' | translate}}" [img]="'content/images/baseline-traits.png'" [isCollapsed]="isCollapsedTraits">
                <ng-container>
                    <jhi-variables-table [variables]="traitVariables"
                                         [showInputVariablesColumn]="true"
                                         [showReorderButtons]="true"
                                         (onAddEvent)="addVariable($event, VariableTypeEnum.TRAIT)"
                                         (onRemoveEvent)="detachOrDeleteFilesIfAny($event, VariableTypeEnum.TRAIT)"
                                         (onRenameEvent)="renameVariableAlias($event)"
                                         [isVariableMoving]="isVariableMoving"
                                         (onMoveEvent)="moveVariable($event, VariableTypeEnum.TRAIT)"
                                         [variableTypeIds]="[VariableTypeEnum.TRAIT]"
                                         [hiddenVariablesFromTable]="HIDE_FROM_VARIABLES_TABLE"
                                         [hiddenVariablesFromSelector]="HIDE_FROM_VARIABLES_TABLE"
                                         [showAddButton]="principal.hasAnyAuthorityDirect(ADD_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS)"
                                         [showDeleteButton]="principal.hasAnyAuthorityDirect(ADD_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS)"
                                         [showEditAliasButton]="principal.hasAnyAuthorityDirect(RENAME_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS)"
                                         (onVariableSelectModalClosed)="onVariableSelectModalClosed()"
                    ></jhi-variables-table>
                </ng-container>
            </jhi-collapsible>
        </div>
        <div class="col-6">
            <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{ 'study-editor.study-dataset.selections' | translate}}" [img]="'content/images/variates.png'" [isCollapsed]="isCollapsedSelections">
                <ng-container>
                    <jhi-variables-table [variables]="selectionVariables"
                                         [showInputVariablesColumn]="false"
                                         [showReorderButtons]="true"
                                         (onAddEvent)="addVariable($event, VariableTypeEnum.SELECTION_METHOD)"
                                         (onRemoveEvent)="detachOrDeleteFilesIfAny($event, VariableTypeEnum.SELECTION_METHOD)"
                                         [isVariableMoving]="isVariableMoving"
                                         (onMoveEvent)="moveVariable($event, VariableTypeEnum.SELECTION_METHOD)"
                                         [variableTypeIds]="[VariableTypeEnum.SELECTION_METHOD]"
                                         [hiddenVariablesFromTable]="HIDE_FROM_VARIABLES_TABLE"
                                         [hiddenVariablesFromSelector]="HIDE_FROM_VARIABLES_TABLE"
                                         [showAddButton]="principal.hasAnyAuthorityDirect(ADD_OBSERVATION_SELECTION_VARIABLES_PERMISSIONS)"
                                         [showDeleteButton]="principal.hasAnyAuthorityDirect(ADD_OBSERVATION_SELECTION_VARIABLES_PERMISSIONS)"
                                         (onVariableSelectModalClosed)="onVariableSelectModalClosed()"
                    ></jhi-variables-table>
                </ng-container>
            </jhi-collapsible>
        </div>
    </div>
<div class="row pt-3">
    <div class="d-flex justify-content-between align-items-center">
        <div></div>
        <div class="d-flex justify-content-end align-items-center">
            <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" class="btn-check" name="btnradio" id="radioAccepted" autocomplete="off"
                       [checked]="!isPendingView" (change)="changeView(false)">
                <label class="btn btn-outline-info fw-bold" for="radioAccepted"><i *ngIf="!isPendingView" class="fa fa-eye me-1"></i>{{ 'study-editor.study-dataset.accepted' | translate}}</label>
                <input  type="radio" class="btn-check" name="btnradio" id="radioPending" autocomplete="off"
                       [checked]="isPendingView" (change)="changeView(true)" [disabled]="!currentDataset?.hasPendingData">
                <label class="btn btn-outline-info fw-bold" for="radioPending"><i *ngIf="isPendingView" class="fa fa-eye me-1"></i> {{ 'study-editor.study-dataset.pending' | translate}}</label>
            </div>
        </div>
    </div>
</div>
<div class="row pt-3">
    <div class="col d-flex justify-content-start align-items-center">
        <label>{{ 'study-editor.study-dataset.select-environment' | translate}}</label>
        <div class="col-3 ms-2">
            <ng-select [items]="environments" [ngModel]="selectedEnvironment" (ngModelChange)="onEnvironmentChange($event)" [clearable]="false">
                <ng-template ng-label-tmp let-item="item">
                    @if (item.instanceNumber) {
                        {{ item.instanceNumber }} -
                    }
                    {{ item.locationName }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    @if (item.instanceNumber) {
                        {{ item.instanceNumber }} -
                    }
                    {{ item.locationName }}
                </ng-template>
            </ng-select>
        </div>
        <label class="ms-2">{{ 'study-editor.study-dataset.filter-by-status' | translate}}</label>
        <div class="col-3 ms-2">
            <ng-select [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange($event)" [clearable]="false">
                <ng-option [value]="1">{{ 'study-editor.study-dataset.filter-all' | translate}}</ng-option>
                <ng-option [value]="2">{{ 'study-editor.study-dataset.filter-out-of-bounds' | translate}}</ng-option>
                <ng-option *ngIf="!isPendingView" [value]="3">{{ 'study-editor.study-dataset.filter-missing' | translate}}</ng-option>
                <ng-option *ngIf="!isPendingView" [value]="4">{{ 'study-editor.study-dataset.filter-out-of-sync' | translate}}</ng-option>
                <ng-option *ngIf="isPendingView" [value]="5">{{ 'study-editor.study-dataset.filter-to-be-overwritten' | translate}}</ng-option>
            </ng-select>
        </div>
    </div>
    <div class="col-3 d-flex justify-content-end fa-align-center">
        @if (isPendingView && currentDataset?.hasPendingData && principal.hasAnyAuthorityDirect(MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS)) {
        <button class="btn btn-info" (click)="acceptDraftData()"><i class="fa fa-check-double"></i> {{ 'study-editor.study-dataset.accept-all' | translate}}</button>
        <button class="btn btn-secondary ms-2" (click)="rejectDraftData()"><i class="fa fa-cancel"></i> {{ 'study-editor.study-dataset.discard' | translate}}</button>
        }
    </div>
</div>
@if (showBatchActions()) {
    <div class="row pt-3">
        <jhi-variable-batch-action [variables]="batchVariables"
                                   (selectedBatchVariable)="onBatchVariableChanged($event)"
                                   [datasetId]="currentDataset?.datasetId"
                                   [isCategoricalDescriptionView]="isCategoricalDescriptionView"
                                   [isPendingView]="isPendingView"
                                   [instanceIds]="selectedEnvironment?.instanceId !== -1 ? [selectedEnvironment?.instanceId] : []"
                                   [filter]="batchVariablesFilter"
                                   (onApplySuccess)="onApplyFilterSuccess()"></jhi-variable-batch-action>
    </div>

}
<div class="row pt-3">
    <div class="row g-2 g-lg-3">
        <div class="col-12 col-xl-auto d-flex flex-wrap align-items-center gap-2">
            <label class="mb-0 text-nowrap" jhiTranslate="global.records.per.page">Records per page:</label>
            <div class="flex-shrink-0">
                <select name="germplasm-table_length" class="form-select form-select-sm"
                        [(ngModel)]="pageSize"
                        (change)="onPageSizeChange($event)">
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                </select>
            </div>

            <jhi-selection-count
                    [showSelectAll]="true"
                    [isSelectAll]="isSelectAll"
                    (selectAllAction)="selectAllChanged($event)"
                    [totalItemsSize]="numberOfFilteredItems || numberOfItems"
                    [selectedItemsSize]="selectedItems.size"
                    (deselectAction)="clearSelected()"></jhi-selection-count>

            <button class="btn btn-sm btn-outline-info" (click)="clearFilters()">
                <i class="fa fa-filter-circle-xmark me-1"></i>
                <span jhiTranslate="study-editor.clear.filter">Clear Filter</span>
            </button>
        </div>
        <div class="col"></div>
        <div class="col-xl-auto ms-xl-auto d-flex flex-wrap align-items-center justify-content-end gap-2">
            <div class="form-check form-switch mb-0">
                <input class="form-check-input" type="checkbox" id="flexSwitchCategoricalDescriptionView" [(ngModel)]="isCategoricalDescriptionView">
                <label class="form-check-label text-nowrap" for="flexSwitchCategoricalDescriptionView" jhiTranslate="study-editor.germplasm-checks.show.categorical.desc">Show Categorical Description</label>
            </div>

            <jhi-column-selector [displayedColumns]="displayedColumns"
                                 [columnDataService]="columnDataService"
                                 [enableHidingByGroup]="true"
                                 (reset)="onColumnSelectorReset()"
                                 (close)="onColumnSelectorClosed($event)"></jhi-column-selector>

            <button class="btn btn-outline-info btn-sm" (click)="visualizePlotData()">
                <i class="fa fa-bar-chart"></i>
            </button>
        </div>
    </div>
</div>
<div class="container-fluid p-0">
    <div class="mt-3">
        @if (isPendingView) {
            <div class="card custom-border-warning border-3">
                <div class="card-body pt-2">
                   <h5 class="card-title"><div class="badge custom-bg-warning"><i class="fa fa-eye me-2"></i>PENDING VIEW</div></h5>
                    <ng-container *ngTemplateOutlet="observationTable"></ng-container>
                </div>
            </div>
        } @else {

            <ng-container *ngTemplateOutlet="observationTable"></ng-container>
        }
    </div>
</div>

<ng-template #observationTable>
        <!-- Data Table -->
        <div class="table-responsive">
            <div class="custom-scroll-style adjustable-height">
                <table id="study-instances-table"
                       class="table table-striped table-bordered table-curved table-editable">
                    <thead class="sticky-header">
                    <tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropColumn($event)">
                        @for (column of displayedColumns; track column.id) {
                            @if (column.selected && column.visible) {
                                <th [ngClass]="getColumnClass(column)" cdkDrag cdkDragHandle>

                                    @if (column.termId === selectedBatchVariable?.termId) {
                                        <i class="fa fa-bookmark bookmark-icon me-2" #bookmark></i>
                                    }

                                    @if (column.termId === CHECKBOX) {
                                        <input type="checkbox" class="form-check-input m-1"
                                               [ngbTooltip]="'global.select.current.page' | translate"
                                               [checked]="isPageSelected()"
                                               (click)="onSelectPage()">
                                    }

                                    @if (getStaticColumnLabelKey(column.termId)) {
                                        {{ getStaticColumnLabelKey(column.termId) | translate }}
                                    } @else {
                                        {{ column.displayName || column.name }}
                                    }

                                    @if (!selectedBatchVariable && column.termId !== CHECKBOX && column.termId !== STATIC_COLUMN_FILES) {
                                        <span class="cursor-pointer ms-1"
                                              #p="ngbPopover"
                                              (click)="showColumnFilterPopover(column, p)"
                                              [autoClose]="'outside'"
                                              [ngbPopover]="columnFilterTemplate"
                                              container="body"
                                              [placement]="['bottom', 'right', 'auto']"
                                              triggers="manual">
                                    <i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
                                            @if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
                                                <i class="ps-1 fa fa-icon-active"
                                                   [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
                                        </i>
                                            }
                                </span>
                                    }
                                </th>
                            }
                        }
                    </tr>
                    </thead>
                    <tbody>
                        @if (items.length !== 0) {
                            @for (entry of items; track entry.observationUnitId; let row = $index) {
                                <tr (click)="toggleSelect($event, row, entry); $event.stopPropagation()"
                                    [class.selected]="isSelected(entry.observationUnitId)"
                                    (mousedown)="preventDefaultOnShiftKey($event)"
                                    (contextmenu)="handleContextMenu($event)">
                                    @for (column of displayedColumns; track column.id; let col = $index) {
                                        @if (column.selected && column.visible && isCellDisabled(entry, column)) {
                                            <td class="disabled" disabled></td>
                                        } @else if (column.selected && column.visible) {
                                            <td *ngIf="column.selected" (click)="selectEditableCell(entry, row, col, $event)"
                                                [class.selected]="editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)"
                                                [class.number-cell]="variableDataTypeIs(column, DataTypeEnum.NUMERIC)"
                                                [class.date-cell]="variableDataTypeIs(column, DataTypeEnum.DATE)"
                                                [class.categorical-cell]="variableDataTypeIs(column, DataTypeEnum.CATEGORICAL)"
                                                [class.error-cell]="getCellData(row, col)?.hasError"
                                                [class.selected-column-cell]="column.termId === selectedBatchVariable?.termId"
                                                [ngClass]="getCellClass(entry, column, CategoricalMatchByEnum.NAME)"
                                                #p="ngbPopover"
                                                (contextmenu)="showContextMenu(entry, column, p, row, col)"
                                                [autoClose]="'outside'"
                                                [ngbPopover]="cellContextMenu"
                                                container="body"
                                                [placement]="['bottom', 'right', 'auto']"
                                                triggers="manual"
                                                (mouseenter)="setHoveredRow(row)"
                                                (mouseleave)="setHoveredRow(null)"
                                            >

                                                @switch (column.termId) {
                                                    @case (CHECKBOX) {
                                                        <input type="checkbox" class="form-check-input m-2"
                                                               [checked]="isSelected(entry.observationUnitId)"
                                                               (change)="toggleSelect($event, row, entry, true)"
                                                               (click)="$event.stopPropagation()"/>
                                                    }
                                                    @case (STATIC_COLUMN_FILES) {
                                                        @if (isFileButtonVisible(entry)) {
                                                            <button class="btn btn-sm btn-outline-info"
                                                                    ngbTooltip="{{ 'file.manager.open.title' | translate }}"
                                                                    [openDelay]="1200"
                                                                    (click)="showFiles(entry.variables['OBS_UNIT_ID'].value)"><i class="fa fa-file"></i></button>
                                                        } @else if (hoveredRow === row) {
                                                            <button class="btn btn-sm btn-outline-info"
                                                                    ngbTooltip="{{ 'file.manager.open.title' | translate }}"
                                                                    [openDelay]="1200"
                                                                    (click)="showFiles(entry.variables['OBS_UNIT_ID'].value)"><i class="fa fa-file"></i></button>
                                                        }<!-- Files content -->
                                                    }
                                                    @case (STATIC_COLUMN_ENTRY_TYPE) {
                                                        <span [title]="getCellValue(entry, column)">{{ getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView }}</span>
                                                    }
                                                    @case (STATIC_COLUMN_GID) {
                                                        @if (hasViewGermplasmDetailsPermission) {
                                                            <a href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)"><truncate-span [textInput]="entry.gid"></truncate-span></a>
                                                        } @else {
                                                            <truncate-span [textInput]="entry.gid"></truncate-span>
                                                        }
                                                    }
                                                    @case (STATIC_COLUMN_DESIGNATION) {
                                                        @if (hasViewGermplasmDetailsPermission) {
                                                            <a href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)">
                                                                <truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
                                                        } @else {
                                                            <truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                        }
                                                    }
                                                    @case (STATIC_COLUMN_FEMALE_PARENT_GID) {
                                                        <jhi-expandable-cell [data]="entry.variables[column.name]?.values"
                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                             (itemClick)="germplasmDetailsPopupService.open(entry.variables['FEMALE_PARENT_GID'].values[$event])" ></jhi-expandable-cell>

                                                    }
                                                    @case (STATIC_COLUMN_FEMALE_PARENT_NAME) {
                                                        <jhi-expandable-cell [data]="entry.variables[column.name]?.values"
                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                             (itemClick)="germplasmDetailsPopupService.open(entry.variables['FEMALE_PARENT_GID'].values[$event])" ></jhi-expandable-cell>
                                                    }
                                                    @case (STATIC_COLUMN_MALE_PARENT_GID) {
                                                        <jhi-expandable-cell [data]="entry.variables[column.name]?.values"
                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                             (itemClick)="germplasmDetailsPopupService.open(entry.variables['MALE_PARENT_GID'].values[$event])" ></jhi-expandable-cell>
                                                    }
                                                    @case (STATIC_COLUMN_MALE_PARENT_NAME) {
                                                        <jhi-expandable-cell [data]="entry.variables[column.name]?.values"
                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                             (itemClick)="germplasmDetailsPopupService.open(entry.variables['MALE_PARENT_GID'].values[$event])" ></jhi-expandable-cell>
                                                    }
                                                    @case (STATIC_COLUMN_STOCK_ID) {
                                                        <truncate-span [textInput]="entry.stockId"></truncate-span>
                                                    }
                                                    @case (STATIC_COLUMN_SAMPLES) {
                                                        @if (entry.samplesCount !== '-') {
                                                            <a href="javascript:void(0)"  (click)="openObservationSampleDetails(entry.variables['OBS_UNIT_ID'].value)">{{ entry.samplesCount }}</a>
                                                        } @else {
                                                            {{ entry.samplesCount }}
                                                        }
                                                    }
                                                    @case (STATIC_COLUMN_GROUPGID) {
                                                        @if (entry.variables[column.name].value === "0") {
                                                            <span>-</span>
                                                        } @else {
                                                            <truncate-span [textInput]="entry.variables[column.name].value"></truncate-span>
                                                        }
                                                    }
                                                    @case (STATIC_COLUMN_OBS_UNIT_ID) {
                                                        <a  href="javascript:void(0)"  (click)="$event.stopPropagation(); openObservationDetails(entry.variables[column.name].value)"><truncate-span [textInput]="entry.variables[column.name].value"></truncate-span></a>
                                                    }
                                                    @default {
                                                        @if (editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)) {
                                                            @if (isPendingView) {
                                                                <jhi-study-inline-editor
                                                                        [bindProperty]="'draftValue'"
                                                                        [observationVariable]="column"
                                                                        [cellData]="getCellData(row, col)"
                                                                        [breedingMethodFilterType]="BreedingMethodFilterTypeEnum.DERIVATIVE_AND_MAINTENANCE_ONLY"
                                                                        (click)="$event.stopPropagation()"
                                                                        (onBlur)="onCellBlur(entry, column, row, col)"
                                                                        (onKeyDown)="onCellKeyDown($event, entry, column, row, col)"
                                                                        [isCategoricalDescriptionView]="isCategoricalDescriptionView"
                                                                        [categoricalBindBy]="'name'"
                                                                        (selectedBreedingMethod)="onSelectedBreedingMethod($event)"
                                                                        [enableCustomCategoricalItem]="true"
                                                                        [categoricalDropdownPosition]="row <= 4 ? 'bottom' : 'auto'"
                                                                >
                                                                </jhi-study-inline-editor>
                                                            } @else {
                                                                <jhi-study-inline-editor
                                                                        [observationVariable]="column"
                                                                        [cellData]="getCellData(row, col)"
                                                                        [breedingMethodFilterType]="BreedingMethodFilterTypeEnum.DERIVATIVE_AND_MAINTENANCE_ONLY"
                                                                        (click)="$event.stopPropagation()"
                                                                        (onBlur)="onCellBlur(entry, column, row, col)"
                                                                        (onKeyDown)="onCellKeyDown($event, entry, column, row, col)"
                                                                        [isCategoricalDescriptionView]="isCategoricalDescriptionView"
                                                                        [categoricalBindBy]="'name'"
                                                                        (selectedBreedingMethod)="onSelectedBreedingMethod($event)"
                                                                        [enableCustomCategoricalItem]="true"
                                                                        [categoricalDropdownPosition]="row <= 4 ? 'bottom' : 'auto'"
                                                                >
                                                                </jhi-study-inline-editor>
                                                            }
                                                        } @else {
                                                            @if (entry.variables[column.name]) {
                                                                @if (isPendingView && getCellValue(entry, column, 'draftValue')) {
                                                                    @if (column.dataType === DataTypeEnum.NUMERIC && (VariableTypeEnum[column.variableType] === VariableTypeEnum.TRAIT || VariableTypeEnum[column.variableType] === VariableTypeEnum.SELECTION_METHOD)) {
                                                                        <truncate-span [textInput]="getCellValue(entry, column, 'displayDraftValue') | categoricalDisplayValue:column:'id':isCategoricalDescriptionView" [showCopyButton]="VariableTypeEnum[column.variableType] !== VariableTypeEnum.TRAIT && VariableTypeEnum[column.variableType] !== VariableTypeEnum.SELECTION_METHOD"></truncate-span>
                                                                        @if (getCellValue(entry, column)) {
                                                                            <span class="text-muted fst-italic">
                                                                                (<truncate-span [textInput]="getCellValue(entry, column, 'displayValue') | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [showCopyButton]="VariableTypeEnum[column.variableType] !== VariableTypeEnum.TRAIT && VariableTypeEnum[column.variableType] !== VariableTypeEnum.SELECTION_METHOD"></truncate-span>)
                                                                            </span>
                                                                        }
                                                                    } @else {
                                                                        <truncate-span [textInput]="getCellValue(entry, column, 'draftValue') | categoricalDisplayValue:column:'id':isCategoricalDescriptionView" [showCopyButton]="VariableTypeEnum[column.variableType] !== VariableTypeEnum.TRAIT"></truncate-span>
                                                                        @if (getCellValue(entry, column)) {
                                                                            <span class="text-muted fst-italic">
                                                                                (<truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [showCopyButton]="VariableTypeEnum[column.variableType] !== VariableTypeEnum.TRAIT"></truncate-span>)
                                                                            </span>
                                                                        }
                                                                    }
                                                                } @else {
                                                                    @if (column.dataType === DataTypeEnum.NUMERIC && (VariableTypeEnum[column.variableType] === VariableTypeEnum.TRAIT || VariableTypeEnum[column.variableType] === VariableTypeEnum.SELECTION_METHOD)) {
                                                                        <truncate-span [textInput]="getCellValue(entry, column, 'displayValue')" [showCopyButton]="false"></truncate-span>
                                                                    } @else {
                                                                        <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'both':isCategoricalDescriptionView" [showCopyButton]="VariableTypeEnum[column.variableType] !== VariableTypeEnum.TRAIT"></truncate-span>
                                                                    }
                                                                    @if (isFileButtonVisibleForVariable(entry, column.termId?.toString())) {
                                                                        <button class="btn btn-sm btn-outline-info float-end"
                                                                                ngbTooltip="{{ 'file.manager.open.title' | translate }}"
                                                                                [openDelay]="1200"
                                                                                (click)="$event.preventDefault(); $event.stopPropagation(); showFiles(entry.variables['OBS_UNIT_ID'].value, column.name)"><i class="fa fa-file"></i></button>
                                                                    }
                                                                }

                                                            }
                                                        }
                                                    }
                                                }
                                            </td>
                                        }
                                    }
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td [attr.colspan]="displayedColumns.length" class="text-center py-3">
                                    {{ 'study-editor.no-records' | translate }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">

            <div>
				@if (numberOfItems !== numberOfFilteredItems) {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredItems), param3: numberOfFilteredItems}"></span>
					<span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfItems}"></span>
				} @else {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredItems), param3: numberOfItems}"></span>
				}
            </div>
            <div>
                <div class="d-inline-block ms-3">
                    <ngb-pagination
                            [collectionSize]="numberOfFilteredItems || numberOfItems"
                            [(page)]="currentPage"
                            [pageSize]="pageSize"
                            [maxSize]="10"
                            [ellipses]="true"
                            [boundaryLinks]="true"
                            [rotate]="true"
                            (pageChange)="onPageChange($event)">
                    </ngb-pagination>
                </div>
                <div class="d-inline-block ms-3">
                    <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                    <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                           [min]="1" [max]="Math.ceil((numberOfFilteredItems || numberOfItems) / pageSize)"
                           [(ngModel)]="currentPage"
                           (change)="onPageChange(currentPage); $event.preventDefault()"/>
                </div>
            </div>
        </div>
</ng-template>

<ng-template #cellContextMenu>
    <div class="context-menu">
        @if (isPendingView && principal.hasAnyAuthorityDirect(MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS)) {
            <button class="btn btn-sm btn-outline-info w-100" type="button" (click)="onAcceptValue()">{{ 'study-editor.study-dataset.accept-value-as-is' | translate}}</button>
        }
        @if (isPendingView && principal.hasAnyAuthorityDirect(MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS) ||
               (!isPendingView && principal.hasAnyAuthorityDirect(MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS))) {
            <button class="btn btn-sm btn-outline-info mt-2 w-100" type="button" (click)="onSetToMissing()">{{ 'study-editor.study-dataset.set-value-to-missing' | translate}}</button>
        }
    </div>
</ng-template>


        <!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
    <div class="column-filter">
        <!-- Sorting Buttons -->
        <div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting">
            <button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
                    [ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
            </button>
            <button (click)="sortColumn(columnDataForFilter,false)" class="btn"
                    [ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
            </button>
        </div>
        <!-- Regular Input Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode !== 'D'" class="mt-2">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   placeholder="{{ 'common.filter.value' | translate }}"
                   [title]="columnDataForFilter.possibleValues?.length ? ('study-editor.study-dataset.no.values.filter.title' | translate) : ''">

            <!-- Filter Options List -->
            <ul class="list-group mt-3" *ngIf="columnDataForFilter.possibleValues">
                <li class="list-group-item" *ngIf="!columnDataForFilter.query">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="columnDataForFilter.isSelectAll"
                               (change)="filterSelectAll(columnDataForFilter, columnDataForFilter.isSelectAll)">
                        <label class="form-check-label" jhiTranslate="global.select.all.items">Select all</label>
                    </div>
                </li>
                <li *ngFor="let option of columnDataForFilter.possibleValues | orderBy:'name' | filter:columnDataForFilter.query:'name'"
                    class="list-group-item">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="option.isSelectedInFilters"
                               (change)="filterSelectOption(option.isSelectedInFilters)">
                        <label class="form-check-label">
                            {{ isCategoricalDescriptionView ? option.displayDescription : option.displayValue }}
                        </label>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Date Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode === 'D'" class="mt-3">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   ngbDatepicker="dp"
                   placeholder="{{ 'common.filter.value' | translate }}">
            <div class="mt-3">
                <ngb-datepicker #dp
                                [(ngModel)]="columnDataForFilter.query"
                                class="well well-sm"
                                (click)="$event.stopPropagation()">
                </ngb-datepicker>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-3">
            <div class="d-flex justify-content-around">
                <div>
                    <button class="btn btn-info ms-2"
                            (click)="filterByColumn(columnDataForFilter)"
                            title="{{ 'global.apply.all.filter' | translate }}" jhiTranslate="apply">
                        Apply
                    </button>
                    <button class="btn btn-secondary ms-2"
                            (click)="resetFilterByColumn(columnDataForFilter)"
                            title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </div>

</ng-template>
